import React from "react";
import PropTypes from "prop-types";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const MapPosition = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={14}
    defaultCenter={{
      lng: props.coordinates[0],
      lat: props.coordinates[1]
    }}
  >
    <Marker
      position={{
        lng: props.coordinates[0],
        lat: props.coordinates[1]
      }}
    />
  </GoogleMap>
));

MapPosition.propTypes = {
  coordinates: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default MapPosition;



// WEBPACK FOOTER //
// ./src/views/pages/trip-active/map-position.js